import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const resendInvite = async (userId) => {
  const { data } = await authApiClient.post(`/users/${userId}/resend-invite`);
  return data;
};

export const useResendInviteHandler = () => {
  const dispatch = useDispatch();
  const { settings } = useTranslatedMessages();
  const teamSnacks = settings.team?.snackbar ?? {};

  const mutation = useMutation({
    mutationFn: resendInvite,
    onSuccess: (data) => {
      dispatch(
        showSnackbar({
          message: data?.message || teamSnacks.resend_success || 'Invite resent successfully',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : teamSnacks.resend_error || 'Failed to resend invite';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
